import { useEffect, useRef } from 'react';
import { browserDeliveryClock } from '../clients/browserClock.client.js';
import { createFrameDelivery } from '../services/frameDelivery.service.js';

export function useFrameDelivery({ enabled, getOwner, getSequence, apply, recover }) {
  const ports = useRef({ getOwner, getSequence, apply, recover });
  ports.current = { getOwner, getSequence, apply, recover };
  const service = useRef(null);
  if (!service.current) service.current = createFrameDelivery({ enabled, clock: browserDeliveryClock,
    getOwner: lane => ports.current.getOwner(lane), getSequence: lane => ports.current.getSequence(lane),
    apply: (lane, envelope) => ports.current.apply(lane, envelope), recover: lanes => ports.current.recover(lanes),
  });
  useEffect(() => { service.current.sync(); });
  useEffect(() => {
    const unlisten = browserDeliveryClock.onVisibility(() => service.current.visibilityChanged());
    // StrictMode re-runs effects on the same instance: cancel owned work, don't retire the service.
    return () => { unlisten(); service.current.cancel(); };
  }, []);
  return service.current;
}
